// A moment as today's pages show it: its age in words, the exact local time
// on hover (lib/time.ts there).
const MINUTE = 60_000
const HOUR = 60 * MINUTE
const DAY = 24 * HOUR

const RELATIVE = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
const EXACT = new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

/** Readable age: "just now", "5 minutes ago", "yesterday", "3 weeks ago". */
export function longAge(iso: string, now: number): string {
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return ''
  const diff = t - now
  const abs = Math.abs(diff)
  if (abs < MINUTE) return 'just now'
  if (abs < HOUR) return RELATIVE.format(Math.round(diff / MINUTE), 'minute')
  if (abs < DAY) return RELATIVE.format(Math.round(diff / HOUR), 'hour')
  if (abs < 7 * DAY) return RELATIVE.format(Math.round(diff / DAY), 'day')
  if (abs < 30 * DAY) return RELATIVE.format(Math.round(diff / (7 * DAY)), 'week')
  if (abs < 365 * DAY) return RELATIVE.format(Math.round(diff / (30 * DAY)), 'month')
  return RELATIVE.format(Math.round(diff / (365 * DAY)), 'year')
}

const CLOCK = new Intl.DateTimeFormat(undefined, { hour: '2-digit', minute: '2-digit' })
const DAY_CLOCK = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

/** A moment as a clock reads it: "10:42" today, with its day before; '' for what is not a time. */
export function clockTime(iso: string, now: number): string {
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return ''
  return new Date(t).toDateString() === new Date(now).toDateString() ? CLOCK.format(t) : DAY_CLOCK.format(t)
}

/** The exact local time, for a hover title; '' for what is not a time. */
export function exactTime(iso: string | null | undefined): string {
  const t = iso ? Date.parse(iso) : NaN
  return Number.isNaN(t) ? '' : EXACT.format(t)
}

export function Time({ iso, className }: { iso: string; className?: string }) {
  const t = Date.parse(iso)
  if (Number.isNaN(t)) return null
  return (
    <time className={className} dateTime={iso} title={EXACT.format(t)}>
      {longAge(iso, Date.now())}
    </time>
  )
}
